import React, { lazy, Suspense } from 'react'
const ContentfulMdsAccordion = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsAccordion'
    )
)
const ContentfulMdsCTABanner = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsCTABanner'
    )
)
const ContentfulMdsEmailSignUp = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsEmailSignUp'
    )
)
const ContentfulMdsFeaturedCards = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsFeaturedCards'
    )
)
const ContentfulMdsFeatureList = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsFeatureList'
    )
)
const ContentfulMdsFeatureModular = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsFeatureModular'
    )
)
const ContentfulMdsFeaturesImageCards = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsFeaturesImageCards'
    )
)
const ContentfulMdsFeaturesThreeColList = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsFeaturesThreeColList'
    )
)
const ContentfulMdsFeaturesTwoColAlternating = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsFeaturesTwoColAlternating'
    )
)
const ContentfulMdsFullwidthAsset = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsFullwidthAsset'
    )
)
const ContentfulMdsGridCardSearch = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsGridCardSearch'
    )
)
const ContentfulMdsHotspotImage = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsHotspotImage'
    )
)
const ContentfulMdsIframeEmbed = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsIframeEmbed'
    )
)
const ContentfulMdsImageLink = lazy(
  () => import('@toasttab/shared/src/components/molecules/ImageLink/ImageLink')
)
const ContentfulMdsInlineCta = lazy(
  () => import('@toasttab/shared/src/components/molecules/InlineCTA/InlineCTA')
)
const ContentfulMdsHeroFullWidth = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Hero/ContentfulMdsHeroFullWidth'
    )
)
const ContentfulMdsLogos = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsLogos'
    )
)
const ContentfulMdsPricing = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsPricing'
    )
)
const ContentfulMdsPricingTable = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsPricingTable'
    )
)
const ContentfulMdsResourcesShowcase = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsResourcesShowcase'
    )
)
const ContentfulMdsRichTextContent = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsRichTextContent'
    )
)
const ContentfulMdsScript = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsScript'
    )
)
const ContentfulMdsShowcaseForm = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsShowcaseForm'
    )
)
const ContentfulMdsShowcasePlatform = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsShowcasePlatform'
    )
)
const ContentfulMdsShowcaseProducts = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsShowcaseProducts'
    )
)
const ContentfulMdsShowcaseRetailTypes = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsShowcaseRetailTypes'
    )
)
const ContentfulMdsShowcaseRXTypes = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsShowcaseRXTypes'
    )
)
const ContentfulMdsShowcaseTestimonials = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsShowcaseTestimonials'
    )
)
const ContentfulMdsSuitesModule = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsSuitesModule'
    )
)
const ContentfulMdsTabs = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Content/ContentfulMdsTabs'
    )
)
const BreadthReleaseList = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/MDS/BreadthReleaseList/BreadthReleaseList'
    )
)
const ContentfulSimpleIconsCards = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/SimpleIcons/ContentfulSimpleIconsCards'
    )
)
const InnovationRelease = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/MDS/InnovationRelease/InnovationRelease'
    )
)
const MainFormContentful = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/molecules/Contentful/Form/MainFormContentful'
    )
)
const ContentfulMdsHero5050 = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/organisms/Contentful/Hero/ContentfulMdsHero5050'
    )
)
const TestimonialCard = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/molecules/CardTypes/TestimonialCard'
    )
)
const Video = lazy(
  () => import('@toasttab/shared/src/components/atoms/Video/Video')
)
const HeadingBlock = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/molecules/HeadingBlock/HeadingBlock'
    )
)
const StickyTabs = lazy(
  () =>
    import('@toasttab/shared/src/components/molecules/StickyTabs/StickyTabs')
)
const SectionWrapper = lazy(
  () =>
    import(
      '@toasttab/shared/src/components/molecules/SectionWrapper/SectionWrapper'
    )
)
const TapReveal = lazy(
  () => import('@toasttab/shared/src/components/molecules/TapReveal/TapReveal')
)

interface ContentfulContentProps {
  content: any
  type: string
}

const ContentfulContent: any = {
  contentfulbreadthreleaselist: BreadthReleaseList,
  contentfulimagewithlink: ContentfulMdsImageLink,
  contentfulmdsaccordion: ContentfulMdsAccordion,
  contentfulmdsctabanner: ContentfulMdsCTABanner,
  contentfulmdsemailsignup: ContentfulMdsEmailSignUp,
  contentfulmdsfeaturelist: ContentfulMdsFeatureList,
  contentfulmdsfeaturemodular: ContentfulMdsFeatureModular,
  contentfulmdsfeatures2colalternating: ContentfulMdsFeaturesTwoColAlternating,
  contentfulmdsfeatures3collist: ContentfulMdsFeaturesThreeColList,
  contentfulmdsfeaturesimagecards: ContentfulMdsFeaturesImageCards,
  contentfulmdsfeaturessimpleicons: ContentfulSimpleIconsCards,
  contentfulmdsfullwidthasset: ContentfulMdsFullwidthAsset,
  contentfulmdsform: MainFormContentful,
  contentfulmdshero5050: ContentfulMdsHero5050,
  contentfulmdsherofullwidth: ContentfulMdsHeroFullWidth,
  contentfulmdshotspotimage: ContentfulMdsHotspotImage,
  contentfulmdsinnovationreleasedeepdive: InnovationRelease,
  contentfulmdslogos: ContentfulMdsLogos,
  contentfulmdsplatformshowcase: ContentfulMdsShowcasePlatform,
  contentfulmdspricing: ContentfulMdsPricing,
  contentfulmdspricingtable: ContentfulMdsPricingTable,
  contentfulmdsproductsshowcase: ContentfulMdsShowcaseProducts,
  contentfulmdsresourcesshowcase: ContentfulMdsResourcesShowcase,
  contentfulmdsretailtypesshowcase: ContentfulMdsShowcaseRetailTypes,
  contentfulmdsrxtypesshowcase: ContentfulMdsShowcaseRXTypes,
  contentfulmdsshowcaseform: ContentfulMdsShowcaseForm,
  contentfulmdsshowcasetestimonials: ContentfulMdsShowcaseTestimonials,
  contentfulmdssuitesmodule: ContentfulMdsSuitesModule,
  contentfulmdstabs: ContentfulMdsTabs,
  contentfulmdsgridcardsearch: ContentfulMdsGridCardSearch,
  contentfulmdsfeaturedcards: ContentfulMdsFeaturedCards,
  contentfulmdsrichtextcontent: ContentfulMdsRichTextContent,
  contentfulmdsscript: ContentfulMdsScript,
  contentfulmdsiframeembed: ContentfulMdsIframeEmbed,
  contentfulmdsinlinecta: ContentfulMdsInlineCta,
  contentfulmdsvideo: Video,
  contentfulmdstestimonial: TestimonialCard,
  contentfulheadingblock: HeadingBlock,
  contentfulstickytabs: StickyTabs,
  contentfulsectionwrapper: SectionWrapper,
  contentfultapreveal: TapReveal
}

const refactorProps = (type: string, props: any) => {
  switch (type) {
    case 'ContentfulMdsFeatures3ColList':
      return {
        ...props,
        theme: 'White'
      }
    default:
      return props
  }
}

const ContentfulContentMDS = ({ content, type }: ContentfulContentProps) => {
  const componentProps = refactorProps(type, { ...content })
  type = type && type.toLowerCase()
  if (typeof ContentfulContent[type] !== 'undefined') {
    return (
      <Suspense fallback={null}>
        {React.createElement(ContentfulContent[type], {
          ...componentProps
        })}
      </Suspense>
    )
  }
}

export default ContentfulContentMDS
